<template>
  <div class="footer">
    <div class="content">
      <div class="top">
        <div class="top_left">
          <div class="hotLine">
            <span>全国统一服务热线</span>
            <span style="font-size: 32px">{{ tel }}</span>
          </div>
          <div class="link">
            友情链接:
            <span v-for="(item, index) in friend_link" :key="item.id">
              <a :href="item.link" target="_blank">{{ item.title }}</a>
              <span v-if="index < friend_link.length - 1"> | </span>
            </span>
          </div>
          <div class="navigation">
            <h1>网站导航</h1>
            <ul>
              <li><router-link to="/">首页</router-link></li>
              |
              <li>
                <router-link to="/development">开发许可专区</router-link>
              </li>
              |
              <li>
                <router-link to="/achievementLibrary">科技成果库</router-link>
              </li>
              |
              <li>
                <router-link to="/technicalDemand">技术需求池</router-link>
              </li>
              |
              <li><router-link to="/pAF_sale">待售专利资产</router-link></li>
              |
              <li><router-link to="/openPatent">开放专利许可</router-link></li>
              |
              <li><router-link to="/paidLicense">付费专利许可</router-link></li>
              |
              <li><router-link to="/trademarkSale">商标</router-link></li>
              |
              <li><router-link to="/cases">成功案例</router-link></li>
              |
              <li><router-link to="/contact">联系我们</router-link></li>
            </ul>
          </div>
        </div>
        <div class="top_right">
          <div class="QRcode">
            <img :src="service_qrcode" alt="" />
            <span>客服二维码</span>
          </div>
          <div class="QRcode">
            <img :src="wechat_qrcode" alt="" />
            <span>微信公众号</span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <span>工匠网络</span>
        <ul>
          <li>{{ copyright }}</li>
          <li>{{ police }}{{ icp }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsite } from "../api/userApi";
export default {
  data() {
    return {
      tel: "",
      service_qrcode: "", //客服二维码
      wechat_qrcode: "", //公总号二维码
      copyright: "", //版权
      police: "", //公安网备案号
      icp: "", //ICP备案号
      friend_link: [],
    };
  },
  async created() {
    // 获取用户信息
    this.getWebsite();
  },
  methods: {
    async getWebsite() {
      try {
        const response = await getWebsite();
        console.log(response.data);
        if (response.code === 1) {
          this.tel = response.data.tel;
          this.service_qrcode = response.data.service_qrcode;
          this.wechat_qrcode = response.data.wechat_qrcode;
          this.copyright = response.data.copyright;
          this.police = response.data.police;
          this.icp = response.data.icp;
          this.friend_link = response.data.friend_link;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.footer {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  background-color: #f7f8fb;
  width: 100%;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0 28px 0;
    border-bottom: 1px solid rgba(28, 29, 37, 0.1);
    .top_left {
      .hotLine {
        display: flex;
        flex-direction: column;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #1c1d25;
          text-align: left;
        }
      }
      .link {
        margin-top: 17px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        text-align: left;
        color: rgba(28, 29, 37, 0.6);
        a {
          color: rgba(28, 29, 37, 0.6);
        }
      }
      .navigation {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 20px;
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #1c1d25;
        }
        ul {
          margin-top: 10px;
          display: flex;
          color: rgba(28, 29, 37, 0.6);
          li {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            margin: 0 5px;
            a {
              color: rgba(28, 29, 37, 0.6);
            }
          }
          li:first-child {
            margin-left: 0;
          }
          li:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .top_right {
      display: flex;
      .QRcode {
        width: 144px;
        height: 171px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        align-items: center;
        margin-left: 45px;
        img {
          width: 144px;
          height: 144px;
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #1c1d25;
          text-align: center;
        }
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    padding: 20px 0 35px 0;
    span {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #1c1d25;
      text-align: left;
    }
    ul {
      margin-top: 13px;
      display: flex;
      justify-content: space-between;
      li {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #1c1d25;
      }
    }
  }
}
</style>
